import { EventObject } from "../../../events/EventObject.js";

export { LayerProxy };

class LayerProxy extends EventObject {

    constructor() {
        super({
            "loading": [],
            "load": []
        });
    }

    setOpacity(opacity) { }
    setProjection(crs) { }
    reload() { }
    addToMap() { }
    removeFromMap() { }
}